module.exports = __webpack_public_path__ + "static/media/yandex-device-stantia.026f751b.png";